/**
 * The alias to this folder is marketing/giftcards
 *
 * Consider using this file as entry point to the container.
 * Ideally, you should import, bind and register all req  required modules or components from here
 */
import GiftCardApplyMixin from './_mixins/giftcard-apply'
import GiftCardFormMixin from './_mixins/giftcard-form'
import GiftCardListMixin from './_mixins/giftcard-list'

import * as vuex from './vuexstore/index'

export default {
  vuex,
  'mixins': {GiftCardApplyMixin, GiftCardFormMixin, GiftCardListMixin},
}

